import { render, staticRenderFns } from "./LightModal.vue?vue&type=template&id=54255c4b&scoped=true"
import script from "./LightModal.vue?vue&type=script&lang=js"
export * from "./LightModal.vue?vue&type=script&lang=js"
import style0 from "./LightModal.vue?vue&type=style&index=0&id=54255c4b&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54255c4b",
  null
  
)

export default component.exports